import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Renderer2 } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable, Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { RutHelper } from "src/app/helpers/rut.helper";
import { DataPredioDireccion } from "src/app/models/data-predio-direccion";
import { OptionsTransportDteEmitido } from "src/app/models/Dte/OptionsTransportDteEmitido";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { TipoDespachoEnum } from "src/app/models/Dte/TipoDespacho.enum";
import { TotalDteEmitido } from "src/app/models/Dte/TotalDteEmitido";
import { Comuna } from "src/app/models/Region/Comuna";
import { StandardResponse } from "src/app/models/StandardResponseAPI";
import { TipoDespacho } from "src/app/models/TipoDespacho";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { MapaService } from "src/app/services/mapa.service";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-item-transporte-dte",
	templateUrl: "./item-transporte-dte.component.html",
	styleUrls: ["./item-transporte-dte.component.scss"],
})
export class ItemTransporteDteComponent implements OnInit {
	@Output() loadingChange = new EventEmitter<boolean>(); // Emisor de eventos para el estado de carga
	@Input() invoiceType: InvoiceType = InvoiceType.GuiaDespacho;

	private totalesDteObservable$: Observable<TotalDteEmitido>;
	public tipoDespacho: TipoDespachoEnum;
	public readonly InvoiceType = InvoiceType;
	public tipoDespachoSource: TipoDespacho[] = [];
	public transporteGroupForm: FormGroup;
	mapaEmbedUrl: SafeResourceUrl | null = null;
	direccionMapa: string = "";

	comunas: Comuna[] = [];

	informacionGeografica: DataPredioDireccion | null = null;
	multiplePredios: DataPredioDireccion[] = [];
	showPrediosTable: boolean = false;
	showManualForm: boolean = false;
	isLoading: boolean = false;
	submitted: boolean = false;

	latitudMapa: number | null = null;
	longitudMapa: number | null = null;

	mostrarManejoMadera: boolean = false;
	public optionsTransport: OptionsTransportDteEmitido = new OptionsTransportDteEmitido();
	private destroy$ = new Subject<void>();
	private restoringTransport = false;
	constructor(private builder: FormBuilder, private _renderer: Renderer2, private sanitizer: DomSanitizer, private modalService: NgbModal, private ref: ChangeDetectorRef, private facturador: FacturacionIndividualService, private mapaService: MapaService, private localStorage: LocalStorageService) {
		this.totalesDteObservable$ = this.facturador.resumenTotalesObservable;
	}

	ngOnInit(): void {
		this.tipoDespachoSource = JSON.parse(this.localStorage.getTipoDespacho() || "[]") as TipoDespacho[];
		this.transportForm();
		this.cargarComunas();
		this.facturador.updateOptionsTransport(this.optionsTransport);
		this.facturador.opcionesTransporteObservable.pipe(takeUntil(this.destroy$)).subscribe((options) => this.applyTransportOptions(options));
	}

	obtenerInfoDisabled(): boolean {
		if (!this.transporteGroupForm.get("manejoMaderaCheckbox")?.value) {
			// Si no se selecciona "Agregar Manejo Madera", deshabilitar el botón
			return true;
		}

		const tipoBusqueda = this.transporteGroupForm.get("tipoBusqueda")?.value;

		if (tipoBusqueda === "direccion") {
			return this.transporteGroupForm.get("comunaDireccion")?.invalid || this.transporteGroupForm.get("direccionMadera")?.invalid || this.transporteGroupForm.get("numeroMadera")?.invalid;
		} else if (tipoBusqueda === "rolAvaluo") {
			return this.transporteGroupForm.get("comunaRolAvaluo")?.invalid || this.transporteGroupForm.get("rolAvaluo")?.invalid;
		}
		// Si no se ha seleccionado ningún tipo de búsqueda, deshabilitar el botón
		return true;
	}

	cargarComunas(): void {
		this.mapaService.obtenerComunas().subscribe(
			(data: Comuna[]) => {
				this.comunas = data;
				this.ref.detectChanges();
			},
			(error) => {
				console.error("Error al cargar las comunas", error);
			}
		);
	}

	abrirMapa(predio: DataPredioDireccion, mapModal): void {
		if (predio.posicionX && predio.posicionY) {
			this.latitudMapa = predio.posicionX;
			this.longitudMapa = predio.posicionY;
			this.direccionMapa = predio.direccion;
			this.mapaEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.getGoogleMapsEmbedUrl(this.latitudMapa, this.longitudMapa));
			this.modalService.open(mapModal, { size: "lg", centered: true });
		} else {
			alert("Latitud y/o Longitud no disponibles para este predio.");
		}
	}

	obtenerInformacionGeograficaDesdeDireccion(): void {
		if (this.transporteGroupForm.get("comuna")?.invalid || this.transporteGroupForm.get("direccionMadera")?.invalid || this.transporteGroupForm.get("numeroMadera")?.invalid) {
			this.transporteGroupForm.markAllAsTouched();
			return;
		}

		const comunaId = this.transporteGroupForm.get("comuna")?.value;
		const direccion = this.transporteGroupForm.get("direccionMadera")?.value;
		const numero = this.transporteGroupForm.get("numeroMadera")?.value;

		this.isLoading = true;
		//this.loadingChange.emit(true);

		this.mapaService
			.obtenerInformacionGeograficaPorDireccion(comunaId, direccion, numero)
			.pipe(
				finalize(() => {
					//this.loadingChange.emit(false);
					this.isLoading = false;
				})
			)
			.subscribe(
				(response: StandardResponse<DataPredioDireccion[]>) => {
					if (response.success) {
						if (Array.isArray(response.data) && response.data.length > 1) {
							// Múltiples predios encontrados
							this.multiplePredios = response.data;
							this.showPrediosTable = true;
							this.showManualForm = false;
							this.informacionGeografica = null;
						} else if (response.data === null || response.data.length === 0) {
							// Ningún predio encontrado
							this.showManualForm = true;
							this.showPrediosTable = false;
							this.informacionGeografica = null;
							// Asegurarse de que el formulario esté vacío y habilitado para edición
							this.transporteGroupForm.patchValue({
								mnzRolOrigen: "",
								prdRolOrigen: "",
								latitudOrigenMadera: "",
								longitudOrigenMadera: "",
								codPlanConaf: "",
							});

							// Opcional: habilitar campos que puedan haber quedado deshabilitados
							this.transporteGroupForm.get("mnzRolOrigen")?.enable();
							this.transporteGroupForm.get("prdRolOrigen")?.enable();
							this.transporteGroupForm.get("latitudOrigenMadera")?.enable();
							this.transporteGroupForm.get("longitudOrigenMadera")?.enable();
						} else {
							// Un solo predio encontrado
							this.informacionGeografica = response.data[0];
							this.showPrediosTable = false;
							this.showManualForm = false;
							this.onSubmit();
							this.transporteGroupForm.patchValue({
								mnzRolOrigen: this.informacionGeografica.manzana,
								prdRolOrigen: this.informacionGeografica.predio,
								latitudOrigenMadera: this.informacionGeografica.datosAreaHomogenea.ubicacionX,
								longitudOrigenMadera: this.informacionGeografica.datosAreaHomogenea.ubicacionY,
								codPlanConaf: "", // O ajusta según corresponda
							});
						}
					} else {
						// Manejar caso de fallo en la respuesta
						console.error("Error en la respuesta del backend:", response.message);
						// Puedes mostrar una notificación al usuario aquí
					}
					this.isLoading = false;
					this.ref.detectChanges();
				},
				(error) => {
					console.error("Error al obtener la información geográfica", error);
				}
			);
	}
	obtenerInformacionGeograficaDesdeRol(): void {
		if (this.transporteGroupForm.get("comuna")?.invalid || this.transporteGroupForm.get("rolAvaluo")?.invalid) {
			this.transporteGroupForm.markAllAsTouched();
			return;
		}

		const comunaId = this.transporteGroupForm.get("comuna")?.value;
		const rolAvaluo = this.transporteGroupForm.get("rolAvaluo")?.value;

		this.isLoading = true;
		//this.loadingChange.emit(true);

		this.mapaService
			.obtenerInformacionGeograficaPorRol(comunaId, rolAvaluo)
			.pipe(
				finalize(() => {
					//this.loadingChange.emit(false);
					this.isLoading = false;
				})
			)
			.subscribe(
				(response: StandardResponse<DataPredioDireccion>) => {
					if (response.success) {
						this.informacionGeografica = response.data;
						this.showPrediosTable = false;
						this.showManualForm = false;
						this.onSubmit();
						this.transporteGroupForm.patchValue({
							mnzRolOrigen: this.informacionGeografica.manzana,
							prdRolOrigen: this.informacionGeografica.predio,
							latitudOrigenMadera: this.informacionGeografica.posicionX,
							longitudOrigenMadera: this.informacionGeografica.posicionY,
							codPlanConaf: "",
						});
					} else {
						// Manejar caso de fallo en la respuesta
						console.error("Error en la respuesta del backend:", response.message);
						// Puedes mostrar una notificación al usuario aquí
					}
					this.isLoading = false;
					this.ref.detectChanges();
				},
				(error) => {
					console.error("Error al obtener la información geográfica", error);
					this.showManualForm = true;
					this.showPrediosTable = false;
					this.informacionGeografica = null;
					// Asegurarse de que el formulario esté vacío y habilitado para edición
					this.transporteGroupForm.patchValue({
						mnzRolOrigen: "",
						prdRolOrigen: "",
						latitudOrigenMadera: "",
						longitudOrigenMadera: "",
						codPlanConaf: "",
					});

					// Opcional: habilitar campos que puedan haber quedado deshabilitados
					this.transporteGroupForm.get("mnzRolOrigen")?.enable();
					this.transporteGroupForm.get("prdRolOrigen")?.enable();
					this.transporteGroupForm.get("latitudOrigenMadera")?.enable();
					this.transporteGroupForm.get("longitudOrigenMadera")?.enable();
				}
			);
	}
	getGoogleMapsEmbedUrl(lat: number, lng: number): string {
		return `https://www.google.com/maps/embed/v1/place?key=${environment.googleMapsApiKey}&q=${lat},${lng}&zoom=18&maptype=satellite`;
	}

	seleccionarPredio(predio: DataPredioDireccion): void {
		this.informacionGeografica = predio;
		this.showPrediosTable = false;
		this.showManualForm = false;
		this.transporteGroupForm.patchValue({
			mnzRolOrigen: predio.manzana,
			prdRolOrigen: predio.predio,
			latitudOrigenMadera: predio.posicionX,
			longitudOrigenMadera: predio.posicionY,
			codPlanConaf: "",
		});
		this.onSubmit();
	}

	transportForm() {
		this.transporteGroupForm = this.builder.group({
			facturaAcompanaTraslado: [this.invoiceType === InvoiceType.GuiaDespacho],
			destinoDistintoReceptor: [this.invoiceType === InvoiceType.GuiaDespacho],
			tipoDespacho: [this.tipoDespachoSource[0] ?? null],
			rutTransporte: ["", [VerificacionRutValidator, Validators.maxLength(10)]],
			patente: ["", Validators.maxLength(8)],
			patenteCarro: ["", Validators.maxLength(8)],
			rutChofer: ["", [VerificacionRutValidator, Validators.maxLength(10)]],
			nombreChofer: ["", Validators.maxLength(30)],
			dirDest: ["", Validators.maxLength(70)],
			cmnaDest: [null, Validators.maxLength(20)],
			fechaSalida: [""],
			horaSalida: [""],
			fechaLlegada: [""],
			manejoMaderaCheckbox: [false],
			numeroMadera: [{ value: "", disabled: true }, [Validators.required, Validators.min(1)]],
			direccionMadera: [{ value: "", disabled: true }, Validators.required],
			mnzRolOrigen: [{ value: "", disabled: true }],
			prdRolOrigen: [{ value: "", disabled: true }],
			codPlanConaf: ["", []],
			latitudOrigenMadera: [{ value: "", disabled: true }],
			longitudOrigenMadera: [{ value: "", disabled: true }],
			rolAvaluo: [{ value: "", disabled: true }, [Validators.required, Validators.pattern(/^\d+-\d+$/)]],
			tipoBusqueda: [{ value: "", disabled: true }, Validators.required],
			comuna: [{ value: "", disabled: true }, Validators.required],
		}, { validators: [this.validarFechasTraslado] });

		this.transporteGroupForm.get("facturaAcompanaTraslado")?.valueChanges.subscribe((checked) => {
			this.optionsTransport.facturaAcompanaTraslado = !!checked;
			this.facturador.updateOptionsTransport(this.optionsTransport);
		});

		this.transporteGroupForm.get("destinoDistintoReceptor")?.valueChanges.subscribe((checked) => {
			this.onSubmit();
		});

		this.transporteGroupForm.get("manejoMaderaCheckbox")?.valueChanges.subscribe((checked) => {
			if (checked) {
				this.transporteGroupForm.get("tipoBusqueda")?.enable();
				this.transporteGroupForm.get("codPlanConaf")?.setValidators([Validators.required]);
			} else {
				this.transporteGroupForm.get("tipoBusqueda")?.disable();
				this.transporteGroupForm.get("tipoBusqueda")?.reset();
				this.transporteGroupForm.get("codPlanConaf")?.clearValidators();
				// Deshabilitar y resetear todos los campos de búsqueda
				this.deshabilitarCamposBusqueda();
			}
			this.transporteGroupForm.get("codPlanConaf")?.updateValueAndValidity();
		});

		this.transporteGroupForm.get("tipoBusqueda")?.valueChanges.subscribe((tipo) => {
			this.deshabilitarCamposBusqueda(); // Primero, deshabilitar todos los campos

			if (tipo === "direccion") {
				this.transporteGroupForm.get("comuna")?.enable();
				this.transporteGroupForm.get("direccionMadera")?.enable();
				this.transporteGroupForm.get("numeroMadera")?.enable();
			} else if (tipo === "rolAvaluo") {
				this.transporteGroupForm.get("comuna")?.enable();
				this.transporteGroupForm.get("rolAvaluo")?.enable();
			}
			this.informacionGeografica = null;
		});
	}

	private deshabilitarCamposBusqueda(): void {
		const tipoBusqueda = this.transporteGroupForm.get("tipoBusqueda")?.value;

		if (tipoBusqueda !== "direccion") {
			this.transporteGroupForm.get("direccionMadera")?.disable();
			this.transporteGroupForm.get("direccionMadera")?.reset();
			this.transporteGroupForm.get("numeroMadera")?.disable();
			this.transporteGroupForm.get("numeroMadera")?.reset();
		}

		if (tipoBusqueda !== "rolAvaluo") {
			this.transporteGroupForm.get("rolAvaluo")?.disable();
			this.transporteGroupForm.get("rolAvaluo")?.reset();
		}

		// Comuna se maneja de forma general
		if (!this.transporteGroupForm.get("tipoBusqueda")?.value) {
			this.transporteGroupForm.get("comuna")?.disable();
			this.transporteGroupForm.get("comuna")?.reset();
		}
	}

	onSubmit() {
		if (this.restoringTransport) {
			return;
		}
		this.actualizarOpcionesDesdeFormulario();
		this.facturador.updateOptionsTransport(this.optionsTransport);
	}

	private actualizarOpcionesDesdeFormulario(): void {
		const form = this.transporteGroupForm.controls;
		const rutTransporte = form.rutTransporte.value as string;
		const rutChofer = form.rutChofer.value as string;
		const informarDestino = this.invoiceType === InvoiceType.GuiaDespacho || !!form.destinoDistintoReceptor.value;
		this.optionsTransport.facturaAcompanaTraslado = this.invoiceType === InvoiceType.GuiaDespacho || !!form.facturaAcompanaTraslado.value;
		this.optionsTransport.destinoDistintoReceptor = informarDestino;
		this.optionsTransport.tipoDespacho = form.tipoDespacho.value?.id ?? form.tipoDespacho.value;
		this.optionsTransport.rutTransporte = rutTransporte ? parseInt(rutTransporte.substring(0, rutTransporte.length - 1)) : undefined;
		this.optionsTransport.dvTransporte = rutTransporte ? rutTransporte.substring(rutTransporte.length - 1) : undefined;
		this.optionsTransport.patente = form.patente.value?.trim();
		this.optionsTransport.patenteCarro = form.patenteCarro.value?.trim() || undefined;
		this.optionsTransport.rutChofer = rutChofer ? parseInt(rutChofer.substring(0, rutChofer.length - 1)) : undefined;
		this.optionsTransport.dvChofer = rutChofer ? rutChofer.substring(rutChofer.length - 1) : undefined;
		this.optionsTransport.nombreChofer = form.nombreChofer.value?.trim();
		this.optionsTransport.dirDest = informarDestino ? form.dirDest.value?.trim() : undefined;
		this.optionsTransport.cmnaDest = informarDestino ? form.cmnaDest.value?.trim() : undefined;
		this.optionsTransport.fechaSalida = form.fechaSalida.value || undefined;
		this.optionsTransport.horaSalida = form.horaSalida.value
			? form.horaSalida.value.length === 5 ? `${form.horaSalida.value}:00` : form.horaSalida.value
			: undefined;
		this.optionsTransport.fechaLlegada = form.fechaLlegada.value || undefined;
		this.optionsTransport.comunaOrigenId = form.comuna.value;
		this.optionsTransport.mnzRolOrigen = form.mnzRolOrigen.value;
		this.optionsTransport.prdRolOrigen = form.prdRolOrigen.value;
		this.optionsTransport.codPlanConaf = form.codPlanConaf.value;
		this.optionsTransport.latitudOrigenMadera = form.latitudOrigenMadera.value || undefined;
		this.optionsTransport.longitudOrigenMadera = form.longitudOrigenMadera.value || undefined;
	}

	private validarFechasTraslado(control: AbstractControl): ValidationErrors | null {
		const salida = control.get("fechaSalida")?.value;
		const llegada = control.get("fechaLlegada")?.value;
		const fechaMinimaSii = "2003-04-01";
		const fechaMaximaSii = "2050-12-31";
		if ((salida && (salida < fechaMinimaSii || salida > fechaMaximaSii)) ||
			(llegada && (llegada < fechaMinimaSii || llegada > fechaMaximaSii))) {
			return { fechaTrasladoFueraRango: true };
		}
		return salida && llegada && llegada < salida ? { fechaLlegadaAnterior: true } : null;
	}

	sidebar(event) {
		const toggleIcon = document.getElementById("sidebar-left");
		const toggle = document.getElementById("content-overlay");
		if (event.currentTarget.className === "sidebar-toggle d-block d-lg-none") {
			this._renderer.addClass(toggleIcon, "show");
			this._renderer.addClass(toggle, "show");
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private applyTransportOptions(options: OptionsTransportDteEmitido): void {
		this.restoringTransport = true;
		const transport = Object.assign(new OptionsTransportDteEmitido(), options ?? {});
		const rutTransporte = transport.rutTransporte != null ? `${transport.rutTransporte}${transport.dvTransporte ? "-" + transport.dvTransporte : ""}` : "";
		const rutChofer = transport.rutChofer != null ? `${transport.rutChofer}${transport.dvChofer ? "-" + transport.dvChofer : ""}` : "";

		const hasManejo = !!transport.codPlanConaf || !!transport.comunaOrigenId || !!transport.mnzRolOrigen || !!transport.prdRolOrigen || !!transport.latitudOrigenMadera || !!transport.longitudOrigenMadera;
		const informarDestino = this.invoiceType === InvoiceType.GuiaDespacho || !!transport.destinoDistintoReceptor || !!transport.dirDest || !!transport.cmnaDest;

		this.transporteGroupForm.patchValue(
			{
				facturaAcompanaTraslado: this.invoiceType === InvoiceType.GuiaDespacho || !!transport.facturaAcompanaTraslado,
				destinoDistintoReceptor: informarDestino,
				tipoDespacho: this.tipoDespachoSource.find((item) => item.id === transport.tipoDespacho) ?? this.tipoDespachoSource[0] ?? null,
				rutTransporte,
				patente: transport.patente ?? "",
				patenteCarro: transport.patenteCarro ?? "",
				rutChofer,
				nombreChofer: transport.nombreChofer ?? "",
				dirDest: transport.dirDest ?? "",
				cmnaDest: transport.cmnaDest ?? null,
				fechaSalida: transport.fechaSalida ? transport.fechaSalida.substring(0, 10) : "",
				horaSalida: transport.horaSalida ? transport.horaSalida.substring(0, 5) : "",
				fechaLlegada: transport.fechaLlegada ? transport.fechaLlegada.substring(0, 10) : "",
				manejoMaderaCheckbox: hasManejo,
				comuna: transport.comunaOrigenId ?? "",
				mnzRolOrigen: transport.mnzRolOrigen ?? "",
				prdRolOrigen: transport.prdRolOrigen ?? "",
				codPlanConaf: transport.codPlanConaf ?? "",
				latitudOrigenMadera: transport.latitudOrigenMadera ?? "",
				longitudOrigenMadera: transport.longitudOrigenMadera ?? "",
			},
			{ emitEvent: false }
		);
		if (hasManejo) {
			this.transporteGroupForm.get("tipoBusqueda")?.enable({ emitEvent: false });
			this.transporteGroupForm.get("comuna")?.enable({ emitEvent: false });
			this.transporteGroupForm.get("mnzRolOrigen")?.enable({ emitEvent: false });
			this.transporteGroupForm.get("prdRolOrigen")?.enable({ emitEvent: false });
			this.transporteGroupForm.get("latitudOrigenMadera")?.enable({ emitEvent: false });
			this.transporteGroupForm.get("longitudOrigenMadera")?.enable({ emitEvent: false });
			this.transporteGroupForm.get("codPlanConaf")?.setValidators([Validators.required]);
			this.transporteGroupForm.get("codPlanConaf")?.updateValueAndValidity({ emitEvent: false });
		} else {
			this.transporteGroupForm.get("tipoBusqueda")?.setValue("", { emitEvent: false });
			this.transporteGroupForm.get("tipoBusqueda")?.disable({ emitEvent: false });
			this.deshabilitarCamposBusqueda();
			this.transporteGroupForm.get("codPlanConaf")?.clearValidators();
			this.transporteGroupForm.get("codPlanConaf")?.updateValueAndValidity({ emitEvent: false });
		}

		this.optionsTransport = transport;
		this.restoringTransport = false;
		this.ref.detectChanges();
	}
}
